import * as React from "react";

function ProfileSmallSvg(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.133 9.058a1.515 1.515 0 00-.275 0A3.683 3.683 0 016.3 5.367c0-2.042 1.65-3.7 3.7-3.7a3.696 3.696 0 01.133 7.392zM5.967 12.133c-2.017 1.35-2.017 3.55 0 4.892 2.291 1.534 6.05 1.534 8.341 0 2.017-1.35 2.017-3.55 0-4.891-2.283-1.526-6.041-1.526-8.341 0z"
        stroke="#292929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ProfileSmallSvg;
